'use strict';


import {common} from '@mixins/common';

export const nsw_common = {
    /**
     *
     * 從learning object 的Technical location 找回對應的值
     *
     * 例如 hkep-url, hkep-them...
     *
     * @param locations array
     * @param key string
     *
     * @return value string
     */
    getTechnicalLocationByUri: function (locations, key) {
        var value = "";

        if (locations) {
            if (locations.length > 0) {
                locations.forEach(function (obj) {

                    if (obj.uri) {
                        var split_uri = obj.uri.split(":");
                        if (split_uri.length === 2) {
                            if (split_uri[0] === key) {
                                value = split_uri[1];
                            }
                        }
                    }

                });
            }

        }


        return value;
    },
    /**
     *
     * 取得location的檔案 資訊
     *
     * Example
     * hkep-file:filepath?original_name=xxxx&size=10213
     *
     * @param locations array
     * @param key string hkep-file
     * @param param original_name
     * @return {string} string xxxx
     */
    getTechnicalLocationFileName: function (locations, key, param) {
        var value = "";
        var uri_value = this.getTechnicalLocationByUri(locations, key);

        if (uri_value) {
            value = common.getParameterByName(param, uri_value);
        }

        return value;
    },
    /**
     *
     * @param relations array
     * @return {string}
     */
    getHasVersionUri: function (relations) {
        var value = "";

        if (relations) {
            relations.forEach(function (obj) {
                if (obj.kind === 'HasVersion') {
                    value = obj.resource.uri;
                }
            });
        }

        return value;
    },

    /**
     *
     * @param content_types array
     * @param content_type_id string
     *
     *
     * @return string|null group|single
     */
    getTypeOfContentType(content_types, content_type_id) {
        var type = null;

        if (content_types) {
            content_types.forEach(function (obj) {
                if (obj.id.uri === content_type_id) {
                    type = obj.type;
                }
            });
        }


        return type;
    },

    /**
     * 從mpms subproduct list 取得 priority
     *
     * @param subproducts array
     * @param subproductcode string
     *
     * @return int|null
     */
    getMpmsPriority(subproducts, subproductcode) {
        var priority = 0;

        if (subproducts && subproductcode) {
            subproducts.forEach(function (obj) {
                if (obj.subproduct_code === subproductcode) {
                    priority = obj.priority;
                }
            });
        }

        return priority;
    },
    /**
     *
     * 取得物件的創建者/更新者
     *
     * 只返固最後更新耆的記錄
     *
     * @param contributes
     */
    getContribute(contributes) {

        var result = {};
        var time = 0;
        if (Array.isArray(contributes)) {

            contributes.forEach(function (obj) {

                var date = new Date(obj.date);
                if (date.getTime() > time) {
                    time = date.getTime();
                    result = obj;

                }

            });

        }

        return result;
    },
    /**
     * example banner record
     * uri: "hkep-banner-image:small#nsw_db/resource/2/5ed4b65b-469b-40f8-91df-b4c30b2de96c?size=12323545&original_filename=logo.png"

     *
     * @param locations
     * @param key
     * @return {string}
     */
    getLocationBanner: function (locations, key) {
        var value = "";
        if (locations) {
            if (locations.length > 0) {
                locations.forEach(function (obj) {

                    if (obj.uri) {
                        var split_uri = obj.uri.split("#");

                        if (split_uri.length === 2) {
                            if (split_uri[0] === "hkep-banner-image:" + key) {
                                value = split_uri[1];
                            }
                        }
                    }

                });
            }

        }

        return value;
    },
    /**
     *
     * @param array_permission array
     * @param permission_id string
     */
    checkUserPermission: function (array_permission, permission_id) {
        var result = false;

        if (array_permission) {

            array_permission.forEach(function (obj) {
                if (obj.id === permission_id) {
                    if (obj.read) {
                        result = true;
                    }
                }
            });

        }

        return result;
    },

    /**
     * 從用戶所擁有的權限 (科目) 來篩選
     *
     * @param arr_subject [{id: subjectcode, value: string}]
     * @param subjectcode
     */
    filterDataListBySubject: function (arr_subject, subjectcode) {

        var result = false;

        if (arr_subject) {
            arr_subject.forEach(function (obj) {
                if (obj.id.toLowerCase() === subjectcode.toLowerCase()) {
                    result = true;
                }
            });
        }


        return result;
    },
    getUriKey(uri) {

        var value = "";

        if (uri) {

            let split = uri.split(":");

            if (split.length === 2) {
                value = split[0];
            }

        }

        return value;
    },
    /**
     *
     * @param uri
     * @return {string}
     */
    getUriValue(uri) {

        var value = "";

        if (uri) {

            let split = uri.split(":");

            if (split.length === 2) {
                value = split[1];
            }

        }

        return value;
    },
    openUrlByPath(full_path)
    {
        let split = full_path.split("?");
        if (split.length > 1) {
            let path = split[0];
            let filename = common.methods.getParameterByName("original_filename", split[1]);
            let file_type = common.methods.getParameterByName("file_type", split[1]);
            let url = window.getFileApiByPath+path+"&filename="+filename+"&file_type="+file_type;

            window.open(url, "_blank");
        }
    },
    getThumbnailUrl(lom)
    {
        let url = "";
        if (lom.technical) {
            if (lom.technical.location) {
                lom.technical.location.forEach(function(item) {
                    if (item.uri) {
                        let split = item.uri.split(":");
                        if (split.length == 2) {
                            if (split[0] == "hkep-thumbnail-url") {
                                url = split[1].replace("|", ":");
                            }
                        }

                    }
                });
            }
        }

        return url;

    },
    getThumbnailImage(lom)
    {
        let image = "";
        if (lom.technical) {
            if (lom.technical.location) {
                lom.technical.location.forEach(function(item) {
                    if (item.uri) {
                        let split = item.uri.split(":");
                        if (split.length == 2) {
                            if (split[0] == "hkep-thumbnail") {
                                image = split[1];
                            }
                        }

                    }
                });
            }
        }

        return getImageApi+image;
    },
    getToolImageFromLocations: function (locations) {
        var value = "";
        if (locations) {
            if (locations.length > 0) {
                locations.forEach(function (obj) {

                    if (obj.uri) {
                        var split_uri = obj.uri.split("#");

                        if (split_uri.length === 2) {
                            if (split_uri[0] === "hkep-tool:module_image") {
                                value = split_uri[1];
                            }
                        }
                    }

                });
            }

        }

        return value;
    },
    getSpecialNewsImageFromLocations: function (locations) {
        var values = [];
        if (locations) {
            if (locations.length > 0) {
                locations.forEach(function (obj) {

                    if (obj.uri) {
                        var split_uri = obj.uri.split("#");

                        if (split_uri.length === 2) {
                            if (split_uri[0].substring(0, split_uri[0].length - 1) === "hkep-special-news:module_image") {
                                values.push(split_uri[1]);
                            }
                        }
                    }

                });
            }

        }
        return values;
    },

};



// WEBPACK FOOTER //
// ./resources/assets/js/mixins/nsw_common.js